import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../environments/environment";
import { Subject } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";
import { AuthService } from "./services/auth/auth.service";
import { ProfileService } from "./services/profile-service/profile.service";
import { Profile } from "./models/profile";
import { takeUntil, filter } from "rxjs/operators";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ApplicationInsightsService } from "./services/app-insight/app-insight.service";
import { MatDialog } from "@angular/material/dialog";
import { NoticeDialogComponent } from "./components/notice-dialog/notice-dialog.component";

@Component({
    selector: "pa-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  contactUrl = environment.contactUrl;
  launchpadUrl = environment.launchpadUrl;
  specialProgramUrl = environment.specialProgramUrl;
  helpUrl = environment.helpUrl;
  profile: Profile;
  userPicture: string;
  isLoading: boolean;

  private onDestroy$ = new Subject<void>();

  constructor(
    private auth: AuthService,
    private router: Router,
    private translate: TranslateService,
    private profileService: ProfileService,
    private readonly dialog: MatDialog,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private appInsightsService: ApplicationInsightsService
  ) {
    //Auth Icon
    iconRegistry.addSvgIcon(
      "auth-seller",
      sanitizer.bypassSecurityTrustResourceUrl("assets/img/authSeller-logo.svg")
    );

    // Translate
    translate.addLangs(["en", "fr", "es"]);

    // this language will be used as a fallback when a translation isn't found in the current language
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    } else {
      this.translate.setDefaultLang("en");
      localStorage.setItem("language", "en");
    }
  }

  ngOnInit() {
    this.router.events
      .pipe(
        takeUntil(this.onDestroy$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((url: NavigationEnd) => {
        this.loginRequired(url.url);
      });
    const language = this.translate.getBrowserLang();
    this.translate.use(language);
    this.profileService.getUserPicture().subscribe((picRes) => {
      this.userPicture = picRes;
    });
    this.profileService.getProfile().subscribe((user) => {
      this.profile = user;
    });
  }

  openNoticesDialog(): void {
    this.dialog.open(NoticeDialogComponent, {
      width: "900px",
      autoFocus: false,
    });
  }


  loginRequired(url: string) {
    if (url) {
      if (url.indexOf("login_required") !== -1) {
        this.auth.login();
      }
    }
  }

  toggleLanguage(language) {
    this.translate.use(language);
    localStorage.setItem("language", language);
  }

  navigateToHelp() {
    if(this.profile){
      this.appInsightsService.logEvent("HelpClicks", {
      Application: "Portal Admin",
      AuthId: this.profile['sub']
      });
    }
    window.open(this.helpUrl);
  }

  navigateToSpecialProgram() {
    window.open(this.specialProgramUrl);
  }

  ngOnDestrory() {
    this.onDestroy$.next();
  }

  signOut() {
    localStorage.clear();
    this.auth.logout();
  }
}
